<script setup>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { annotationMixin } from '@/mixins/annotationMixin'
import GeoPlotlyLineChart from '../plotly-chart/GeoPlotlyLineChart.vue'
import { useSectionVisualisationStore } from '@/store/sectionVisualization'

const props = defineProps({
  chartRef: { type: String, required: true }
})

const store = useStore()

const sectionVisualizationStore = useSectionVisualisationStore()

const currentTopoProfile = computed(() => store.state.topoProfile.currentItem)
const topoSingleLine = computed(() => store.getters['topoProfilePoint/getPlotData'])
const soilLayerScatter = computed(() => store.getters['soilLayer/getPlotData'])
const xLineSoilLayer = computed(() => store.getters['soilProfile/getPlotData'])
const currentSchematisation = computed(() => store.state.stabSchematisation.currentItem)

const getChartYAxisRange = computed(() => (id) => {
  return store.getters['topoProfilePoint/getChartYAxisRange'](id)
})

const refPlot = computed(() => props.chartRef)

const soilCompositionPlotData = computed(() => {
  return [...soilLayerScatter.value(), ...topoSingleLine.value(), ...xLineSoilLayer.value()]
})

onMounted(async () => {
  if (currentSchematisation.value) {
    const dikeProfileId = currentSchematisation.value.dike_profile
    await sectionVisualizationStore.getVisualizationData(dikeProfileId)
  }
})
</script>

<template>
  <GeoPlotlyLineChart
    class="fill-height"
    :extra-data="soilCompositionPlotData"
    :show-legend="true"
    :ref="refPlot"
    :yAxisRange="getChartYAxisRange(currentTopoProfile?.id)"
  />
</template>
